import { get } from "../../../helpers/axios"


const BASE_PATH = "/rates"

export const getUserBusinessRates = () =>
  get(`${BASE_PATH}/user-business-rate`)
